<div id="cl-wrapper" class="login-container login-theme">

    <div class="row no-margin-top" style="display: flex; justify-content: center; align-items: center; height: 800px;">


        <div class="block-flat" style="width: 600px;">
            <div class="header">
                <h3 class="text-center">
                    <img alt="logo" class="img-responsive logo-img">
                </h3>
            </div>
            <div class="form-horizontal" style="font-size: 14px;">
                <div class="content">
                    <h2 style="text-align: center;">{{'ACCEPT' | translate}} {{this.typeOfApproval}} {{'NUMBER' |
                        translate}}: <h3>{{this.numberOfApproval}} ?</h3></h2>

                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <div style="justify-content: center; display: flex;">
                        <div>
                            <button style="width: 150px; border-radius: 4px;" type="button"
                                class="btn btn-success btn-lg " (click)="this.acceptFunc()">
                                <h2>{{'ACCEPT'|translate}} </h2>
                            </button>
                        </div>
                        <div>
                            <button style="width: 150px; border-radius: 4px;" type="button"
                                class="btn btn-danger btn-lg " (click)="this.declineFunc()">
                                <h2>{{'REJECT'|translate}} </h2>
                            </button>
                        </div>
                    </div>

                </div>


            </div>

        </div>



    </div>
</div>